// Imposto NF Access na conta direta por item (D-0112, Rafael 27/10). As planilhas antigas foram fechadas com o
// 19,05% na conta direta (base × p) e precisam entrar no sistema batendo; as novas seguem na conta invertida
// (base × p ÷ (1 − p)). Uma caixa por item, vale em todas as etapas, qualquer cliente, nacional ou internacional.
// Espelho de accessapi app/Services/OrcamentoImpostoNfContaDireta.php.
//
// Campo `impostoNfContaDireta` (padrão false = invertida): linha sem o campo (legado) continua como sempre.
import { ehSomenteVisualizacao } from './somenteVisualizacaoPolicy';
import { normalizarPagamentoExterior } from './pagamentoExteriorPolicy';

export const CAMPO_IMPOSTO_NF_CONTA_DIRETA = 'impostoNfContaDireta';
// Só em memória: no grupo AGÊNCIA da Chiesi com 1945 manual, a conta da NF é a da 1945 (não a de cada linha).
export const CAMPO_IMPOSTO_NF_CONTA_DIRETA_GRUPO = 'impostoNfContaDiretaGrupo';
export const ALIQUOTA_NF_ACCESS = 0.1905;

const flag = (valor) => {
    if (typeof valor === 'boolean') return valor;
    if (typeof valor === 'number') return valor === 1;
    return ['1', 'true', 'sim', 'yes', 'on'].includes(String(valor ?? '').trim().toLowerCase());
};

const numero = (valor) => {
    const n = Number(String(valor ?? '').replace(',', '.'));
    return Number.isFinite(n) ? n : 0;
};

export const ehImpostoNfContaDireta = (linha) => flag(linha?.[CAMPO_IMPOSTO_NF_CONTA_DIRETA]);

// Conta da NF que incide sobre a linha: a da 1945 manual do grupo, quando houver; senão a da própria linha.
export const ehContaDiretaDaNfDoGrupo = (linha) => (
    linha && Object.prototype.hasOwnProperty.call(linha, CAMPO_IMPOSTO_NF_CONTA_DIRETA_GRUPO)
        ? flag(linha[CAMPO_IMPOSTO_NF_CONTA_DIRETA_GRUPO])
        : ehImpostoNfContaDireta(linha)
);

// A NF do grupo é linear (Σ base × p ÷ (1 − p)): a linha na conta direta entra com base × (1 − p), e a conta
// invertida devolve base × p para ela. A base mostrada segue a crua.
export const fatorBaseNf = (linha) => (ehImpostoNfContaDireta(linha) ? 1 - ALIQUOTA_NF_ACCESS : 1);

// "% Imposto NF" próprio da linha sobre o valor dela: invertida = ÷ (1 − p), direta = × (1 + p).
export const comNfPropria = (valor, percentual, linha) => {
    const p = numero(percentual);
    if (!(p > 0 && p < 100)) return valor;
    return ehImpostoNfContaDireta(linha) ? valor * (1 + p / 100) : valor / (1 - p / 100);
};

// Linha que pode gerar Imposto NF Access tem a caixa: 1945, base da NF virtual (inserirCalculoTotalPlanilha),
// "% Imposto NF" próprio e linha paga no exterior (Coordenação). Mesma regra de OrcamentoImpostoNfContaDireta::aceita.
export const aceitaImpostoNfContaDireta = (linha) => {
    const codigo = String(linha?.produto?.codigo ?? '').trim().toUpperCase();
    // A 1945 automática do SERVIÇOS AGÊNCIA também vem com linhaCalculadaImpostoAccess: ela tem a caixa.
    if (codigo === 'IMPOSTO_NF_ACCESS' || (linha?.linhaCalculadaImpostoAccess && codigo !== '1945')) return false;
    if (ehSomenteVisualizacao(linha)) return false;
    const imposto = numero(linha?.imposto);
    return codigo === '1945'
        || flag(linha?.inserirCalculoTotalPlanilha)
        || (imposto > 0 && imposto < 100)
        || pagoNoExterior(linha);
};

// Sem importar moedaFornecedorPolicy (ela importa feeIntelligence, que usa esta policy).
const pagoNoExterior = (linha) => {
    try { return normalizarPagamentoExterior(linha?.pagamento_exterior) === true; } catch (e) { return false; }
};
